import { render, staticRenderFns } from "./ControlAccessCardForm.vue?vue&type=template&id=d80b7384&"
import script from "./ControlAccessCardForm.vue?vue&type=script&lang=js&"
export * from "./ControlAccessCardForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports